// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const Glossary: MarkdocTagRegistration = {
  tag: 'glossary',
  component: 'Glossary',
  children: ['strong', 'em', 'text'],
  attributes: {
    term: {
      type: String,
      description: 'The term that is defined in the glossary.yaml file.',
      matches(config) {
        if (config.glossary) {
          return Object.keys(config.glossary);
        }
      },
    },
  },
};
